function AboutSection() {
  return (
    <section id="about" className="bg-white text-deepgreen px-6 py-24 overflow-hidden">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Left: Image or Illustration */}
        <div className="hidden md:block relative" data-aos="fade-right">
          <div className="absolute top-4 left-4 w-full h-full border-2 border-gold rounded-lg z-0"></div>
          <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl">
            <img
              src="/soj.jpg"
              alt="Scales of Justice"
              className="w-full h-auto object-cover transform hover:scale-105 transition duration-700"
            />
          </div>
        </div>

        {/* Right: Text Content */}
        <div data-aos="fade-left">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-deepgreen">About Our Firm</h2>
          <div className="w-20 h-1 bg-gold mb-8"></div>

          <div className="space-y-6 text-lg leading-relaxed text-gray-700">
            <p>
              <strong>Elvis Nanda, Weke & Co. Advocates</strong> is a professional law firm founded in <strong>May 2022</strong>, built on the values of humility, trust, and competence.
              We strive to restore public confidence in the legal profession by offering practical legal solutions delivered with integrity and precision.
            </p>
            <p>
              Headquartered at <strong>The Professional Centre, Parliament Road</strong>, with an annex office at <strong>Studio House, Nairobi CBD</strong>,
              we are strategically located to serve both corporate and individual clients across Kenya.
            </p>
            <p>
              Our leadership includes <strong>Odira Elvis W. Nanda</strong>, an experienced litigator with over 8 years of practice, and <strong>Mary Stella Weke</strong>,
              a conveyancing expert with extensive real estate law experience. Alongside a dedicated team of associate advocates and staff, we provide a full-service legal experience.
            </p>
            <p>
              The firm is fully digitized, equipped with 24-hour legal research capabilities, and driven by a commitment to efficiency, client satisfaction, and continuous legal innovation.
            </p>
          </div>

          <blockquote className="mt-8 text-deepgreen font-serif italic text-xl border-l-4 border-gold pl-6 py-2 bg-gray-50 rounded-r-lg">
            “Proficiency, Efficiency, Integrity and Competence is our call.”
          </blockquote>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
